const drawerWidth = 248;

const drawerBg = {
  width: drawerWidth,
  flexShrink: 0,
  "& .MuiDrawer-paper": {
    width: drawerWidth,
    backgroundColor: "#032b25",
    backgroundImage: "none",
    background: "linear-gradient(180deg, #02241f 0%, #043029 45%, #011d19 100%)",
    borderRight: "1px solid rgba(255, 255, 255, 0.08)",
    boxShadow: "4px 0 24px rgba(0, 0, 0, 0.15)",
    color: "#ffffff",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
};

export const drawerStyles = {
  temporaryDrawer: {
    ...drawerBg,
    display: { xs: "block", sm: "none" },
  },
  permanentDrawer: {
    ...drawerBg,
    display: { xs: "none", sm: "block" },
  },
  brandHeader: {
    display: "flex",
    alignItems: "center",
    gap: 1.5,
    padding: "16px 18px",
    borderBottom: "1px solid rgba(255, 255, 255, 0.08)",
    flexShrink: 0,
    textDecoration: "none",
    color: "inherit",
  },
  brandLogo: {
    width: 36,
    height: 36,
    borderRadius: "10px",
    bgcolor: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "4px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "contain",
    },
  },
  navList: {
    flex: 1,
    overflowY: "auto",
    px: 1,
    py: 1,
    "&::-webkit-scrollbar": {
      width: "4px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "rgba(255, 255, 255, 0.15)",
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "rgba(255, 255, 255, 0.3)",
    },
  },
  listItems: {
    padding: "7px 12px",
    margin: "2px 4px",
    borderRadius: "8px",
    transition: "all 0.15s ease",
    position: "relative",
    "&.Mui-selected": {
      backgroundColor: "rgba(255, 255, 255, 0.15)",
      color: "#ffffff",
      "&::before": {
        content: '""',
        position: "absolute",
        left: "-4px",
        top: "15%",
        height: "70%",
        width: "3.5px",
        backgroundColor: "#34d399",
        borderRadius: "0 4px 4px 0",
      },
      "& .MuiListItemIcon-root": {
        color: "#34d399",
      },
      "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.2)",
      },
    },
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.08)",
      borderRadius: "8px",
    },
  },
  icons: {
    minWidth: "36px",
    color: "rgba(255, 255, 255, 0.75)",
    marginLeft: "2px",
    "& svg": {
      fontSize: "1.2rem",
    },
  },
  orderBadge: {
    "& .MuiBadge-badge": {
      minWidth: 17,
      height: 17,
      padding: "0 4px",
      border: "2px solid #032b25",
      borderRadius: "9px",
      backgroundColor: "#f59e0b",
      color: "#1f2937",
      fontSize: "0.6rem",
      fontWeight: 800,
      lineHeight: 1,
    },
  },
  text: {
    "& span": {
      fontWeight: 600,
      fontSize: "13.5px",
      letterSpacing: "0.01em",
    },
  },
  userFooter: {
    padding: "12px 14px",
    borderTop: "1px solid rgba(255, 255, 255, 0.08)",
    backgroundColor: "rgba(0, 0, 0, 0.18)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexShrink: 0,
  },
  appBar: {
    display: { sm: "none" },
    width: { sm: `calc(100% - ${drawerWidth}px)` },
    ml: { sm: `${drawerWidth}px` },
    backgroundColor: "#004d40",
  },
  appBarIcon: { mr: 1, display: { sm: "none" } },
  drawerBox: { width: { sm: drawerWidth }, flexShrink: { sm: 0 } },
  outletBox: {
    flexGrow: 1,
    minWidth: 0,
    p: { xs: 2, sm: 3 },
    width: { sm: `calc(100% - ${drawerWidth}px)` },
    minHeight: "100vh",
    backgroundColor: "#f8fafc",
  },
};
